/**
 * The interviewer can end a message with answer options on their own line:
 *   [[opties: Minder dan 10 | 10 tot 50 | Meer dan 50]]
 * The chat shows them as buttons. The marker never reaches the database or
 * the visitor, and typing a free answer always stays possible.
 */
export const QUICK_REPLY_PATTERN = /\n?\s*\[\[opties:([^\]]*)\]\]\s*$/i;

const MAX_OPTIONS = 4;
const MAX_OPTION_LENGTH = 60;

export function parseQuickReplies(text: string): { text: string; options: string[] } {
  const match = text.match(QUICK_REPLY_PATTERN);
  if (!match) return { text: text.trimEnd(), options: [] };

  const options = match[1]
    .split('|')
    .map((o) => o.trim())
    .filter((o) => o.length > 0 && o.length <= MAX_OPTION_LENGTH)
    .slice(0, MAX_OPTIONS);

  return { text: text.slice(0, match.index).trimEnd(), options };
}

/** Hides a marker while it is still streaming in, complete or not. */
export function hideQuickReplyMarker(text: string): string {
  const start = text.lastIndexOf('[[');
  if (start === -1) return text;
  return text.slice(0, start).trimEnd();
}
